import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const QuoteListContainer = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 4px 4px 0 rgb(0 0 0 / 25%);
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  .table-container {
    padding: 0 30px;
  }
`;

export const HeaderWrapper = styled.div`
  background-color: #004c83;
  display: flex;
  justify-content: space-between;
  padding: 18px 30px;
`;

export const Title = styled.h2`
  width: 100%;
  text-align: center;
  font-family: "Lato";
  font-size: 22px;
  line-height: 22px;
  margin: 30px 0 20px 0;
  color: #ff5200;
  text-transform: capitalize;
  font-weight: bold;
`;

export const AddCenterProducts = styled.button`
  background-color: transparent;
  border: 1px solid white;
  border-radius: 4px;
`;

export const OuterWrapper = styled.div`
  padding: 2rem;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center};
  > div {
    margin-right: 1rem;
  }
`;

export const FilterFlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom:30px;
  align-items: center};
  > div {
    margin-right: 1rem;
  }
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
  gap: ${(props) => (props?.gap ? props.gap : "1rem")};
  opacity: ${(props) => (props?.opacity ? props.opacity : 1)};
  margin-right: ${(props) => (props?.marginRight ? props.marginRight : "0px")};
  margin-bottom: ${(props) =>
    props?.marginBottom ? props.marginBottom : "0px"};
`;
export const GridLoaderItem = styled.div`
  text-align: center;
`;

export const ProductContainer = styled.section`
  width: 100%;
  box-shadow: 2px 2px 2px 2px rgb(0 0 0 / 20%);
  background-color: white;
  padding: 10px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  padding: 10px;
  opacity: ${(props) => props.opacity};
  .table-container {
    padding: 0 30px;
  }
`;

export const ProductDetail = styled.div`
  font-size: 14px;
  margin-bottom: 10px;
  color: #767676 !important;
  font-weight: normal;
  justify-self: ${(props) =>
    props?.contentStart ? props.contentStart : "start"};
`;

export const TotalPrice = styled.div`
  font-size: 14px;
  margin-bottom: 10px;
  color: #474747 !important;
  margin-right: 10px;
  font-weight: 700;
  justify-self: end;
`;

export const ActionButtons = styled.div`
  justify-self: end;
`;

export const ButtonWrapper = styled.div`
  justify-self: end;
`;

export const ButtonWrapperRelative = styled.div`
  justify-self: end;
  position: relative;
`;

export const ButtonData = styled(BaseButton)`
  background: ${(props) => props.colour};
  border: 1px solid ${(props) => props.colour};
  font-weight: normal;
  width: auto;
  margin-right: 5px;
  font-size: 14px;
  font-family: lato;
`;

export const CreateButton = styled(BaseButton)`
  background: #00aeea;
  border: 1px solid #00aeea;
  font-weight: normal;
  width: auto;
  font-size: 16px;
  font-family: lato;
  margin-bottom: 0px;
  line-height: 35px;
  white-space: nowrap;
  border-bottom-left-radius: ${(props) =>
    props.displayDropdown ? "0px" : "4px"};
  border-bottom-right-radius: ${(props) =>
    props.displayDropdown ? "0px" : "4px"};
`;

export const BlockRow = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  padding: 0 10px;
  opacity: ${(props) => (props?.opacity ? props.opacity : 1)};
}
`;

export const SliderGridRow = styled.div`
  display: grid;
  grid-template-columns:${(props) => props.column};
  gap: 1.25rem;
}
`;

export const TransportDetail = styled.div`
  font-size: 14px;
  font-style: italic;
  color: #767676 !important;
`;

export const FilterOuter = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 74%;
`;

export const GlobalSearch = styled.div`
  display: flex;
  align-items: center;
`;

export const ProductLabel = styled.div`
  font-style: italic;
  color: #474747 !important;
  font-size: 14px;
  font-weight: 600;
`;

export const InfoContainer = styled.div`
  font-size: 14px;
`;

export const InfoContainerMargin = styled.div`
  font-size: 14px;
  justify-self: end;
  margin-left: 10px;
  margin-right: 10px;
`;

export const NoQuote = styled.span`
  font-family: Lato;
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 0px;
  text-align: left;
  color: #cccccc;
`;

export const GrayPara = styled.p`
  color: #767676;
  font-style: italic;
  font-size: ${(props) => (props?.fontSize ? props.fontSize : "16px;")};
  &:hover {
    text-decoration: none !important;
  }
`;

export const SalesmanPara = styled.p`
  color: #474747;
  font-style: normal;
`;

export const DueDateSpan = styled.div`
  color: ${(props) => props.color};
  font-style: ${(props) => props.fontStyle};
  display: flex;
  font-size: 16px;
  font-weight: ${(props) => (props?.fontWeight ? props.fontWeight : "normal")};
`;

export const DunningDateSpan = styled.div`
  font-weight: 700;
`;

export const QuoteItemsContainer = styled.div`
  margin-left: 10px;
  display: ${(props) => (props?.display ? props.display : "none")};
`;

export const Separator = styled.hr`
  background: #ededed;
  border: 1px solid #ededed;
  width: 100%;
  margin-top: 15px !important;
  margin-bottom: 15px !important;
`;

export const ServiceText = styled.div`
  font-weight: 700;
  display: flex;
`;

export const QuoteIdContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const EnquiryIdHyphen = styled.span`
  text-decoration: ${(props) => props.decoration ?? "underline"};
  cursor: pointer;
  color: ${(props) => props.color ?? "#fff"};
  font-weight: ${(props) => props.weight ?? "400"};
  font-size: 16px;
`;

export const GridSubLabel = styled.div`
  color: ${(props) => props.color ?? "#0a4986"};
  font-weight: 700;
  font-size: ${(props) => props.fontSize ?? "16px"};
  text-align: left;
`;
